/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../Form';
import { form as FormStyle } from '../../style/form';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class ResetPasswordForm extends Form {
    state = {
        isFormSubmit: false,
        data: {
            email: '',
        },
        errors: {},
    };

    schema = {
        email: Joi.string()
            .email({ minDomainSegments: 2 })
            .trim()
            .max(50)
            .required()
            .label('Email Address'),
    };

    doSubmit = () => {
        const { data } = this.state;
        data.callBack = {};
        this.setState({ isFormSubmit: true });
        this.props.handleSubmitResetPassword(data);
    };

    handleContinueShoppingClicked = () => {
        const { data } = this.state;
        data.callBack = { url: '/' };
        this.props.handleClickContinueShopping(data);
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { email } = this.props.pageData;
        if (email) {
            this.setState({ data: { email } });
        }
    };

    render() {
        /* eslint-disable max-len */
        const { classes } = this.props;
        const { data, isFormSubmit } = this.state;
        const submitData = {};

        return (
            <>
                {!isFormSubmit ? (
                    <p className="margin-bottom-2x">
                        If you have already registered with us and you need to
                        reset your password, we can send the link to reset your
                        password. <br /><br />
                        Enter your Email Address below, and click
                        &quot;Submit&quot;. You should receive an email with the
                        link to reset your password in 1 to 2 minutes.{' '}
                    </p>
                ) : (
                    <>
                        <h1>Thank You!</h1>
                        <p className="margin-bottom-2x email-sent-paragraph">
                            Your request has been submitted for this email
                            address: <strong>{data.email}</strong>. If we find
                            this address on file, an email will be sent to you
                            shortly that contains the link to reset your
                            password.{' '}
                            <strong>
                                Don&apos;t forget to check your email!{' '}
                            </strong>{' '}
                        </p>
                    </>
                )}
                {!isFormSubmit ? (
                    <form
                        onSubmit={(event) => this.handleSubmit(event, submitData)}
                        className={`${classes.form} row`}
                    >
                        <div>
                            {this.renderInput({
                                name: 'email',
                                label: 'Email Address',
                                type: 'email',
                                pattern: '^[0-9_a-zA-Z\\s\\.\\-@]*$',
                                length: 50,
                            })}
                        </div>

                        <div className="margin-top-2x">
                            {this.renderButton({
                                label: 'Submit',
                                className: 'buttonHD submit-btn',
                                onClick: null,
                                type: 'submit',
                            })}
                        </div>
                    </form>
                ) : (
                    <div className="row margin-top-2x margin-bottom-2x">
                        {this.renderButton({
                            label: 'Continue Shopping',
                            className: 'buttonHD continue-shopping-btn',
                            onClick: this.handleContinueShoppingClicked,
                            type: 'button',
                            isValidated: false,
                        })}
                    </div>
                )}
                <p className="margin-bottom-2x">
                    To ensure you receive the email containing your temporary
                    password, please add{' '}
                    <strong>Account-Update@1800flowers.com</strong> to your
                    address book now. Also be sure to check your
                    &quot;spam&quot; folder.{' '}
                </p>
            </>
        );
    }
}

ResetPasswordForm.defaultProps = {
    isAuthenticated: false,
};

ResetPasswordForm.propTypes = {
    classes: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
        pageData: newState.pageData,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitResetPassword: (data) => dispatch(EventDispatcher.handleSubmitResetPassword(data)),
    handleClickContinueShopping: (data) => dispatch(EventDispatcher.handleClickContinueShopping(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(ResetPasswordForm));
